import React from "react";

export const PwaIcon = ({ size = 40, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 192 192"
    className={className}
    aria-label="Niper — Nihil Perditum"
  >
    <circle cx="96" cy="96" r="62" fill="none" stroke="#09090B" strokeWidth="8" />
    <path d="M96 58 V96 L122 112" stroke="#09090B" strokeWidth="8" strokeLinecap="round" fill="none" />
    <path
      d="M130 62 C152 70 152 106 130 118 C118 112 114 98 114 88 C114 78 118 68 130 62 Z"
      fill="#34C759"
      stroke="#166534"
      strokeWidth="4"
      strokeLinejoin="round"
    />
    <path d="M128 72 C124 82 124 96 128 110" stroke="#166534" strokeWidth="3" fill="none" strokeLinecap="round" />
  </svg>
);

export default PwaIcon;
